import styled from "styled-components";

export const MinimumGamblingAgeBox = styled.div<{isShownInHeader: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    &:hover {
        opacity: 0.5;
    }
`